import { CONST } from './constants';
import { itrState, itrAction } from 'store/initialState';

export default (
  state: itrState,
  action: itrAction,
): { [key: string]: (act: itrAction) => itrState } => {
  const reducer = {
    [CONST.APP_INIT](act: itrAction) {
      return {
        ...state,
        appStarted: !state?.appStarted,
      };
    },
  };
  return reducer;
};
